module.exports = __webpack_public_path__ + "static/BT-desktop-5-3eb7eb692009b3e3ab56ad498c949114.jpg";